import LazyLoad from 'vanilla-lazyload';

const myLazyLoad = new LazyLoad();

const updateLazyLoad = () => {
  // After your content has changed...
  myLazyLoad.update();
}

export { updateLazyLoad }
